import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateService } from '@codeandweb/ngx-translate';

import { TableModule } from '@app/primeng-overrides/table';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToolbarModule } from 'primeng/toolbar';

import { GlobalModule } from '@app/_global/global.module';
import { NomenclatureService } from '@app/nomenclature/nomenclature.service';
import { EventManagerService, IEventListener } from '@global/event-manager.service';
import { Article, FutureVersionArticle } from '../texte.model';

import { uid } from '@helpers/utils';


@Component({
	selector: 'future-versions-article-dialog',
	templateUrl: './future-versions-article-dialog.html',
	providers: []
})
export class FutureVersionArticleComponent implements OnInit, IEventListener {

	private _uuid: string = uid();
	get uuid(): string { return this._uuid; }

	article: Article;
	future_versions: FutureVersionArticle[];
	expandedVersions: Record<number/*otm_id*/, boolean> = {};


	constructor(
		private config: DynamicDialogConfig,
		private dialogRef: DynamicDialogRef,
		private eventManager: EventManagerService,
		private translateService: TranslateService,
		private nomenclatureService: NomenclatureService,
	) {
		this.article = config.data.article;
		this.future_versions = config.data.future_versions;
	}

	ngOnInit(): void {
		this.eventManager.registerEvent('close-modals', this, (args: any) => this.dialogRef.close());

		// On agrandit tous les articles courts par défaut et on arrange les art_ordre
		this.future_versions.forEach((version: FutureVersionArticle, index: number) => {
			if (version.art_corps && version.art_corps.length < 100) {
				this.expandedVersions[version.otm_id] = true;
			}
		});
	}


	ngOnDestroy(): void {
		this.eventManager.unregisterEvent('close-modals', this);
	}

}


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		GlobalModule,
		ButtonModule,
		InputTextareaModule,
		TableModule,
		ToolbarModule
	],
	exports: [FutureVersionArticleComponent],
	declarations: [FutureVersionArticleComponent]
})
export class FutureVersionArticleModule { }

